import React, { useContext, useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Header from "../components/Header";
import "./home.scss";
import PromoterNewTab from "../components/PromotersPages/New";
import Accepted from "../components/PromotersPages/Accepted";
import Seen from "../components/PromotersPages/Seen";
import AuthClient from "../api/AuthClient";
import {
  PromoterGroupsContext,
  PromoterGroupsProvider,
} from "../GlobalContext/promoterGroupsContext";
import { CitiesInfoContext } from "../AllCitiesContext";
import PromoterBannerCityLink from "../components/PromotersPages/PromoterBannerCityLink";

const authClient = new AuthClient();
const promoterLastTabViewStorageKey = "PromoterLastTabView";
const defaultPromoterTab = "new";

const isValidPromoterTab = (tab: string | null): tab is "new" | "seen" | "accepted" =>
  tab === "new" || tab === "seen" || tab === "accepted";

const PromoterGroupsBootstrap: React.FC = () => {
  const { fetchGroups, hasFetched } = useContext(PromoterGroupsContext);
  const { selectedCity } = useContext(CitiesInfoContext);

  useEffect(() => {
    if (!hasFetched) {
      fetchGroups();
    }
  }, [hasFetched, fetchGroups]);

  useEffect(() => {
    if (hasFetched) {
      fetchGroups();
    }
  }, [selectedCity, hasFetched, fetchGroups]);

  return null;
};

const PromotersMode: React.FC = () => {
  const [activeTab, setActiveTab] = useState<"new" | "seen" | "accepted">(() => {
    const storedTab = sessionStorage.getItem(promoterLastTabViewStorageKey);

    if (isValidPromoterTab(storedTab)) {
      return storedTab;
    }

    return defaultPromoterTab;
  });

  const handleTabSelect = (tab: string | null) => {
    if (!isValidPromoterTab(tab)) {
      return;
    }

    setActiveTab(tab);
    sessionStorage.setItem(promoterLastTabViewStorageKey, tab);
  };

  return (
    <PromoterGroupsProvider>
      <PromoterGroupsBootstrap />
      <div className="promoterHeaderWrap">
        <Header />
        {activeTab === "accepted" ? null : <PromoterBannerCityLink />}
      </div>
      <div className="centerGroup">
        <div className="desktopUI">
          <Container className="p-0">
            <Tabs
              activeKey={activeTab}
              onSelect={handleTabSelect}
              id="fill-tab-example"
              className="mb-3"
              fill
            >
              <Tab eventKey="new" title="New">
                <PromoterNewTab authClient={authClient} />
              </Tab>
              <Tab eventKey="seen" title="Seen">
                <Seen />
              </Tab>
              <Tab eventKey="accepted" title="Accepted">
                <Accepted authClient={authClient} />
              </Tab>
            </Tabs>
          </Container>
        </div>
      </div>
    </PromoterGroupsProvider>
  );
};

export default PromotersMode;
